import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/styles';

import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutline from '@material-ui/icons/RemoveCircleOutline';

const styles = theme => ({
  quantity: {
    position: 'relative',
    display: 'inline-block',
    width: '30px',
    marginLeft: '5px',
    marginRight: '5px',
    textAlign: 'center'
  },
  text: {
    position: 'relative',
    marginRight: '15px'
  },
  icon: {
    position: 'relative',
    bottom: 1
  }
});

class QuantityInput extends React.Component {
  static propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    classes: PropTypes.object,
    label: PropTypes.string,
    disableIncrement: PropTypes.bool,
    disableDecrement: PropTypes.bool
  };

  static defaultProps = {
    value: 0
  };

  handleDecrementClick = event => {
    const { value, onChange } = this.props;

    if (value === 1) {
      return;
    }

    onChange({
      target: {
        name,
        value: parseInt(value) - 1
      }
    });
  };

  handleIncrementClick = event => {
    const { value, onChange } = this.props;

    onChange({
      target: {
        name,
        value: parseInt(value) + 1
      }
    });
  };

  render() {
    const {
      value,
      classes,
      label,
      disableIncrement,
      disableDecrement
    } = this.props;
    return (
      <span>
        <Typography component="span" variant="h4" className={classes.text}>
          {label}
        </Typography>
        <IconButton
          name="decrement"
          onClick={this.handleDecrementClick}
          aria-label="decrement item quantity"
          className={classes.icon}
          data-testid="menu-item-detail-decrement-button"
          disabled={disableDecrement}
        >
          <RemoveCircleOutline data-testid="decrement-counter" />
        </IconButton>
        <Box component="span">
          <Typography
            data-testid="quantity-value"
            variant="h4"
            className={classes.quantity}
          >
            {`${value}`}
          </Typography>
        </Box>
        <IconButton
          className={classes.icon}
          name="increment"
          aria-label="increment item quantity"
          disabled={disableIncrement}
          onClick={this.handleIncrementClick}
          data-testid="menu-item-detail-increment-button"
        >
          <AddCircleOutline data-testid="increment-counter" />
        </IconButton>
      </span>
    );
  }
}

export default withStyles(styles)(QuantityInput);
